import React, {Component} from "react"

import {H3} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage, FormattedCurrency, FormattedDate, FormattedRelative, injectIntl, InjectIntl} from "@irati/utils/lang"
import TenantWalletBalanceQuery, {TenantWalletBalanceQueryResult} from "@irati/wallet/apollo/query/TenantWallet"
import {TopUpTypes} from "@irati/wallet/enums"
import {BankName, BankAccountNumber, BankSortCode} from "@irati/wallet/constants/bankTransferDetails"

import {StyledModal, LeftAlign, TopCard, GreyCard, InnerCard, StyledButton} from "./styled"
import ModalHeader from "./ModalHeader"
import Row from "./Row"

interface RowType {
  label: string,
  value: string
}

interface Props extends InjectIntl {
  onClose: () => void,
  show: boolean,
  details: TenantWalletTopup,
  title: string,
  mainMessage: string,
  firstRow: RowType,
  secondRow: RowType,
  invoiceToMessage: string,
  pending?: boolean,
  messages?: string[]
}

class TopUpConfirmationPopup extends Component<Props> {
  static defaultProps = {
    pending: false
  }
  render() {
    const {onClose, show, details, title, mainMessage, firstRow, secondRow, invoiceToMessage, messages, pending} = this.props
    const {amount, currency, metadata} = details
    const {createdAt} = metadata
    const isBankTransfer = details.payment.type === TopUpTypes.BankTransfer

    const dateText = isBankTransfer ? "wallet.tenant.topUp.invoicePopUp.dueDate" : "wallet.tenant.topUp.invoicePopUp.date"

    return (
      <StyledModal show={show} useMobileStyling={false} onHide={onClose} onExited={onClose} renderHeader={() => <ModalHeader />}>
        <TopCard medium>
          <H3 small>{title}</H3>
          <Para center large>
            <FormattedCurrency isCents currency={currency} value={amount} /> Credit
          </Para>
          {mainMessage && <LeftAlign>{mainMessage}</LeftAlign>}
          {invoiceToMessage && <LeftAlign>{invoiceToMessage}</LeftAlign>}
          {messages && messages.map((message: string) => <LeftAlign>{message}</LeftAlign>)}
        </TopCard>

        <TenantWalletBalanceQuery>
          {({data: {tenantWallet}}: TenantWalletBalanceQueryResult) => (
            <GreyCard medium>
              <InnerCard>
                <Row leftText={firstRow.label} rightText={firstRow.value} />
                <Row leftText={secondRow.label} rightText={secondRow.value} />
                <Row
                  leftText={<FormattedMessage id={dateText} />}
                  rightText={<FormattedDate day="numeric" month="long" year="numeric" value={createdAt} />} />

                {isBankTransfer ?
                  <>
                    <Row
                      leftText={<FormattedMessage id="wallet.tenant.topUp.invoicePopUp.bank" />}
                      rightText={BankName} />
                    <Row
                      leftText={<FormattedMessage id="wallet.tenant.topUp.invoicePopUp.bankAccountNumber" />}
                      rightText={BankAccountNumber} />
                    <Row
                      isLast
                      leftText={<FormattedMessage id="wallet.tenant.topUp.invoicePopUp.bankSortCode" />}
                      rightText={BankSortCode} />
                  </> :
                  <>
                    <Row
                      leftText={<FormattedMessage id="wallet.tenant.topUp.invoicePopUp.timeAdded" />}
                      rightText={<FormattedRelative value={createdAt} />} />
                    <Row
                      isLast
                      leftText={<FormattedMessage id="wallet.tenant.topUp.invoicePopUp.wallet" />}
                      rightText={<FormattedCurrency
                        isCents={false}
                        currency={tenantWallet.currency}
                        value={tenantWallet.availableBalance} />}
                      pending={pending && <FormattedCurrency
                        isCents
                        currency={tenantWallet.currency}
                        value={amount} />} />
                  </>
                }
              </InnerCard>
              <StyledButton primary large full onClick={onClose}>
                <FormattedMessage id="wallet.tenant.topUp.invoicePopUp.button" />
              </StyledButton>
            </GreyCard>
          )}
        </TenantWalletBalanceQuery>
      </StyledModal>
    )
  }
}

export default injectIntl(TopUpConfirmationPopup)
